// Kode pendek untuk link halaman Anime (?s= seri, ?w= episode), supaya URL
// tidak memuat path/nama file asli. Hash cyrb53 dari path lengkap, base36.
// Rumus yang SAMA dipakai bot (discord-bot/anime-preview.js) untuk kartu
// pratinjau Discord - kalau diubah, ubah keduanya.
export function linkId(text) {
    let h1 = 0xdeadbeef;
    let h2 = 0x41c6ce57;
    for (let i = 0; i < text.length; i++) {
        const ch = text.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
    return (4294967296 * (2097151 & h2) + (h1 >>> 0)).toString(36);
}

// Link lama memakai path asli (diawali "/"), link baru memakai kode.
export function matchesLink(value, path) {
    return value === path || value === linkId(path);
}
